export default "__VITE_ASSET__D$HDLvHX__"